import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
class EvaluationTab extends SubscriptionViewModel {
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.TabPage = tabPage;
        this.ReportViewModel = parent;
        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });
        this.SelectedEvaluationRow.subscribe(() => {
            if (this.SelectedEvaluationRow() == null) {
                if (this.enableButton != undefined) {
                    this.enableButton("EditReportEvaluation", false);
                    this.enableButton("DeleteReportEvaluation", false);
                }
            }
            else {
                if (this.enableButton != undefined) {
                    this.enableButton("EditReportEvaluation", true);
                    this.enableButton("DeleteReportEvaluation", Bao.Utils.String.IsNullOrWhitespace(this.SelectedEvaluationRow().CompleteDateJs));
                }
            }
        });
        Bao.bindEvent('checklist-evaluation:refresh', () => this.Refresh());
    }
    TabPage;
    Bao = Bao;
    ReportViewModel;
    OriginalTabTitle: string = "";
    CompleteCheck = () => {
        return true;
    };
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    EvaluationCollection = ko.observableArray([]);
    SelectRow = (item) => {
        this.SelectedEvaluationRow(item);
        return true;
    };
    SelectedEvaluationRow = ko.observable<any>({});
    enableButton: (actionpKey: string, enabled: boolean) => void;
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddReportEvaluation":
                this.ShowCreateEvaluationDialog(this.ReportViewModel.ReportId());
                break;
            case "EditReportEvaluation":
                if (this.SelectedEvaluationRow() != null) {
                    this.EditReportEvaluation(this.SelectedEvaluationRow());
                }
                break;
            case "DeleteReportEvaluation":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteReportEvaluation"), "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.DeleteReportEvaluation(this.SelectedEvaluationRow());
                    }
                });
                break;
            case "RefreshReportEvaluation":
                this.RefreshGrid();
                break;
        }
    };
    RefreshGrid = () => {
        this.TabPage.IsLoading(true);
        //TODO
        return Bao.post("EvaluationTab/GetEvaluationCollection", JSON.stringify({
            reportId: this.ReportViewModel.ReportId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedEvaluationRow(null);
            this.TotalRows(0);
            this.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.EvaluationCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + this.TotalRows() + ")");
        });
    };
    CreateEvaluation = (folderStructureChecklistId, reportId) => {
        this.TabPage.IsLoading(true);
        //TODO
        return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        }).then(_ => Bao.raiseEvent('checklist-evaluation:refresh', null));
    };
    DeleteReportEvaluation = (item) => {
        //TODO
        Bao.post("EvaluationTab/DeleteEvaluation", JSON.stringify({
            evaluationId: ko.unwrap(item.EvaluationId)
        }), () => {
            this.RefreshGrid();
        });
    };
    EditReportEvaluation = (item) => {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    ShowCreateEvaluationDialog = (reportId) => {
        window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
            var dialog = new vm(this.TabPage, this);
            dialog.Show();
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult == true) {
                    this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), this.ReportViewModel.ReportId());
                }
            });
        });
    };
    Refresh = () => {
        return this.RefreshGrid();
    };
    Save = () => { };
    loaded = () => {
        return Bao.post('EvaluationTab/LoadColumns', JSON.stringify({
            shiftbookTabId: this.TabPage.ObjectId(),
        }), (result) => {
            this.Columns([]);
            if (result !== false) {
                this.Columns(result);
            }
        })
            .then(_ => this.Refresh())
            .then(() => {
                return this.subscribe(this.PageSize, () => {
                    if (this.PageIndex() === 0) {
                        return this.RefreshGrid();
                    }
                    else {
                        return this.PageIndex(0);
                    }
                });
            });
    };
    canClose = () => {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    };

    init = () => {
        this.OriginalTabTitle = this.TabPage.Title();
    }
}
export default EvaluationTab;